<template>

  <div class="inputs-div">

    <b-card border-variant="info" class="text-center">
      <template v-slot:header>
        <div>教師あり学習データ【Label:{{in_name}}】<b-icon icon="pencil" variant="primary" font-scale="0.8" @click="editLabel()" class="labelpen"></b-icon></div>
      </template>
      <div class="col_5">
        <InputImg v-for="iimg of getAllImages(this.in_id)" v-bind:key="iimg.img_num" :in_id="in_id" :img_numb="iimg.img_num"></InputImg>
        <div>
          <b-button variant="outline-secondary" class="aiimg-plus" @click="plusImage(false)">＋</b-button>
        </div>
      </div>
    </b-card>
    <div class="action-del" v-if="this.in_id>1">
      <b-icon icon="trash" font-scale="1.2" @click="delInput" class="color-gray"></b-icon>
    </div>

    <!-- Edit Label modal -->
    <div class="modal-overlay" v-if="modalLabelShow">
      <div class="modal-content">
        <div class="modalpad">
          <h5>Label名変更</h5>
          <br/>
          <table class="table table-striped labelTable">
            <tbody>
              <tr>
                <td>現Label名</td>
                <td>{{in_name}}</td>
              </tr>
              <tr>
                <td>変更Label名</td>
                <td><b-form-input v-model="setLabelName" placeholder="Enter Label name"></b-form-input></td>
              </tr>
            </tbody>
          </table>
          <br/>
          <div>
            <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">Cancel</b-button>
            <b-button variant="outline-primary" size="sm" class="btnw" @click="setLabel()">設定</b-button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import InputImg from '@/components/InputImg.vue'

export default {
  name: 'inputcard',
  props: {
    in_id: { type: Number, default: 0 },
    in_name: { type: String, default: '1' }
  },
  data () {
    return {
      modalLabelShow: false,
      setLabelName: ''
    }
  },
  components: {
    InputImg
  },
  computed: {
    ...mapGetters([ 'getAllImages' ])
  },
  methods: {
    alerttest (btnNum) {
      alert('testDrop:' + String(btnNum))
    },
    delInput () {
      this.$store.dispatch('delInput', this.in_id)
    },
    plusImage (createFlag) {
      this.$store.dispatch('addImage', {in_id: this.in_id, createFlag: createFlag})
    },
    editLabel () {
      this.modalLabelShow = true
    },
    setLabel () {
      this.$store.dispatch('updLabel', {in_id: this.in_id, in_label: this.setLabelName})
      this.cancelModal()
    },
    cancelModal () {
      this.modalLabelShow = false
    }
  },
  created () {
    // this.plusImage(true) // 必ず一つは表示（Load時に問題となるため,store[ADD_INPUT]時にImage追加）
    // this.iimages = this.allImages(this.in_id)
  }
}
</script>

<style scoped>
.inputs-div {
  position: relative;
  margin-bottom: 10px;
}
.labelpen {
  margin: 0 0 0 -7px;
}
.action-drop {
  position: absolute;
  height: 40px;
  top: 10px;
  right: 10px;
}
.aiimg {
  margin: 2px 0;
}
.aiimg-plus {
  height: 55px;
  width : 55px;
  border : dotted 1px #999 ;
}
.action-del {
  position: absolute;
  height: 40px;
  top: 10px;
  left: 10px;
}
.col_5{
  width: 100%;
  display: flex;
  display: -ms-flexbox; /* IE10 */
  flex-wrap: wrap;
  -ms-flex-wrap: wrap; /* IE10 */
}
.col_5 > div{
  width: 20%;
  padding: 0 0 10px 0;
}
div.card-body {
  max-height: 235px;
  overflow: auto;
}
.aimodel-table {
  font-size: 90%;
}
.aimodel-table td {
  padding: 7px 0 7px 0;
}
.labelTable td, select, option {
  font-size: 95%;
  text-align: center;
  vertical-align: middle;
}
.modalpad {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/InputCard.vue